// Function to add missing days in case key value pair for date  is unavailable
export const getMissingDates = (resKeys) => {
  let missingDates = []
  for (let i = 0; i < resKeys.length - 1; i++) {
    let curr = resKeys[i]
    let next = resKeys[i + 1]
    let currentDate = new Date(curr)
    let nextDate = new Date(next)
    let dateDiff = Math.ceil(Math.abs(nextDate.getTime() - currentDate.getTime()) / (1000 * 3600 * 24))
    while (dateDiff > 1) {
      let missingDate = new Date(currentDate.setDate(currentDate.getDate() + 1))
      missingDates.push(missingDate.toISOString().slice(0, 10))
      dateDiff--
    }
  }
  return missingDates
}
// Converts String date into YY-MM-DD format
export function convertToFormattedString(str) {
  let date = new Date(str),
    mnth = ('0' + (date.getMonth() + 1)).slice(-2),
    day = ('0' + date.getDate()).slice(-2)
  return [date.getFullYear(), mnth, day].join('-')
}
